import React from "react";

function ResumeForm({ resumeData, setResumeData, onProceed }) {
  // Handles all changes for inputs and textareas
  const handleChange = (e) => {
    const { name, value } = e.target;
    setResumeData({ ...resumeData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onProceed(); // proceed to next step with updated data
  };

  const inputStyle = {
    width: "100%",
    marginBottom: 15,
    padding: 10,
    borderRadius: 6,
    border: "1px solid #ccc",
    fontSize: 14,
    boxSizing: "border-box",
  };

  const labelStyle = { fontWeight: "bold", marginBottom: 6, display: "block" };
  const sectionStyle = { marginBottom: 20 };

  return (
    <form onSubmit={handleSubmit} class="resume-form">
      <h2 style={{ marginBottom: 30, marginTop: -35 }}>📝 Enter Resume Details</h2>

      {/* Standard Input Fields */}
      {["name", "email", "phone", "position"].map((field) => (
        <div key={field} style={sectionStyle}>
          <label htmlFor={field} style={labelStyle}>
            {field.charAt(0).toUpperCase() + field.slice(1)}
          </label>
          <input
            id={field}
            name={field}
            type={field === "email" ? "email" : field === "phone" ? "tel" : "text"}
            placeholder={`Enter your ${field}`}
            value={resumeData[field] || ""}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </div>
      ))}

      {/* Multi-line Text Areas for Rich Fields */}
      {["summary", "education", "experience", "skills"].map((field) => (
        <div key={field} style={sectionStyle}>
          <label htmlFor={field} style={labelStyle}>
            {field.charAt(0).toUpperCase() + field.slice(1)}
          </label>
          <textarea
            id={field}
            name={field}
            placeholder={`Enter your ${field}`}
            value={resumeData[field] || ""}
            onChange={handleChange}
            rows={6}
            style={{ ...inputStyle, resize: "vertical" }}
            required
          />
        </div>
      ))}

      <div style={sectionStyle}>
        <label htmlFor="languages" style={labelStyle}>Languages</label>
        <input
          id="languages"
          name="languages"
          placeholder="e.g. English, Hindi, Spanish"
          value={resumeData.languages || ""}
          onChange={handleChange}
          required
          style={inputStyle}
        />
      </div>

      <button
        type="submit"
        style={{
          marginTop: 15,
          padding: "10px 20px",
          fontSize: 16,
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
        }}
      >
        Proceed To Payment
      </button>
    </form>
  );
}

export default ResumeForm;
